/* [04] VRT V3 - real Shopify materials, model information and hero-to-buy composition */
(() => {
 "use strict";
 const rootSelector='.product-information[data-pdp-reference-04="true"]';
 const instances=new WeakMap(),seen=new Set();
 let raf=0;
 let headerPortal=null;

 // Shopify renders #header-group inside .page-wrapper. On mobile PDPs the
 // independent page scroller can carry its supposed fixed header away.
 // Keep the ORIGINAL node and all event handlers; temporarily move its group
 // to <body> so its fixed positioning uses the visual viewport.
 function attachHeaderToViewport(){
   if(headerPortal)return;
   const group=document.getElementById("header-group");
   if(!group||!group.parentNode||!document.body)return;
   const marker=document.createComment("[04] PDP header home");
   group.parentNode.insertBefore(marker,group);
   headerPortal={group,marker};
   document.body.insertBefore(group,document.body.firstChild);
   document.documentElement.classList.add("pdpref04-header-portal");
 }
 function restoreHeaderPosition(){
   if(!headerPortal)return;
   const {group,marker}=headerPortal;
   if(marker.parentNode)marker.parentNode.replaceChild(group,marker);
   else marker.remove();
   headerPortal=null;
   document.documentElement.classList.remove("pdpref04-header-portal");
 }
 const tidy=s=>(s||"").replace(/\s+/g," ").trim().toLowerCase();
 const mobile=()=>matchMedia("(max-width: 1024px), (hover: none) and (pointer: coarse) and (max-width: 1366px)").matches;

 function accordionRow(details,type){
   return [...details.querySelectorAll(".accordion details")].find(node=>{
     const name=tidy(node.querySelector("summary")?.textContent);
     return type==="details"? /^(details|informazioni|information)\b/.test(name) :
       /^(materials|materiali)\b/.test(name);
   }) || null;
 }
 function rowWrapper(row){return row?.closest("accordion-custom")||row;}
 function ensureMaterialsDisclosure(state){
   const original=accordionRow(state.details,"materials");
   if(original)return original;
   const materialNote=state.details.querySelector(".pdp-material-note:not(.pdpref04-material-in-accordion)");
   const host=state.details.querySelector(".accordion");
   if(!materialNote||!host)return null;
   state.materialOriginal={
     note:materialNote,parent:materialNote.parentNode,nextSibling:materialNote.nextSibling
   };
   const wrapper=document.createElement("div");
   wrapper.className="pdpref04-generated-materials";
   state.generatedMaterials=wrapper;
   const row=document.createElement("details");
   row.className="details";
   const summary=document.createElement("summary");
   summary.className="details__header";
   const heading=document.createElement("span");
   heading.className="pdpref04-heading-label";
   heading.textContent="Materials";
   summary.append(heading);
   const body=document.createElement("div");
   body.className="details-content";
   materialNote.classList.add("pdpref04-material-in-accordion");
   body.append(materialNote);
   row.append(summary,body);
   wrapper.append(row);
   host.append(wrapper);
   return row;
 }
 function makeHeaderLinks(state){
   const {details}=state;
   const source=details.querySelector(".pdp-shipping-summary");
   const header=details.querySelector(":scope > .group-block > .group-block-content");
   if(!header||header.querySelector(".pdpref04-intro"))return;
   const intro=document.createElement("nav");
   intro.className="pdpref04-intro";intro.setAttribute("aria-label","Product details and materials");
   const links=document.createElement("div"); links.className="pdpref04-intro__links";
   for(const [type,text] of [["details","Details"],["materials","Materials"]]){
     const row=accordionRow(details,type);if(!row)continue;
     const btn=document.createElement("button");btn.type="button";btn.textContent="["+text+"]";
     btn.addEventListener("click",()=>revealAccordion(row));
     links.append(btn);
     const wrapper=rowWrapper(row);
     state.originalRows.push({row,wrapper,originalOpen:row.open});
     // The native Details/Materials accordions MUST remain in the lower
     // information list. Keep them closed, but never hide their headings.
     row.removeAttribute("open");
     wrapper?.classList?.remove("pdpref04-source-collapsed","pdpref04-source-revealed");
   }
   if(!links.children.length)return;
   intro.append(links);
   state.intro=intro;
   // Insert immediately after the real Shopify price, before its shipping summary.
   // The existing grid is flattened via display: contents.
   if(source?.parentElement)source.insertAdjacentElement("beforebegin",intro);
   else header.firstElementChild?.insertAdjacentElement("afterend",intro);
 }
 function moveMaterials(state){
   const row=accordionRow(state.details,"materials");
   const note=state.details.querySelector(".pdp-material-note:not(.pdpref04-material-in-accordion)");
   const body=row?.querySelector(".details-content");
   if(!row||!note||!body)return;
   if(!state.materialOriginal)state.materialOriginal={
     note,parent:note.parentNode,nextSibling:note.nextSibling
   };
   note.classList.add("pdpref04-material-in-accordion");
   body.insertAdjacentElement("afterbegin",note);
 }
 function moveModelInfo(state){
   const details=state.details;
   const guide=details.querySelector(".pdp04-size-guide-link");
   const source=details.querySelector('[class*="text_8MUfyJ"]');
   const legend=guide?.closest("legend");
   if(!guide||!source||!legend||legend.querySelector(".pdpref04-model-note"))return;
   const text=source.textContent.trim();
   if(!text)return;
   const note=document.createElement("span");note.className="pdpref04-model-note";
   note.textContent=text;
   guide.insertAdjacentElement("afterend",note);
   state.modelNote=note;state.modelSource=source;
   source.classList.add("pdpref04-model-source-hidden");
 }
 function revealAccordion(row){
   if(!row)return;
   const wrapper=rowWrapper(row);
   wrapper?.classList.remove("pdpref04-source-collapsed");
   wrapper?.classList.add("pdpref04-source-revealed");
   row.open=true;
   requestAnimationFrame(()=>{
     row.scrollIntoView({behavior:matchMedia("(prefers-reduced-motion: reduce)").matches?"auto":"smooth",block:"start"});
     row.querySelector("summary")?.focus({preventScroll:true});
   });
 }
  function menuIsOpen(){
   return !!document.querySelector('.nav04--mobile [data-nav04-drawer][open], header-drawer #Details-menu-drawer-container[open]');
 }

 // The white dock is a navigation surface: swiping UP on it should bring
 // the existing native product details up into view, instead of scrolling
 // through every remaining photo. No popup and no cloned Shopify markup.
 //
 // We crop the remaining *photo strip* at its current viewport boundary;
 // the real product details become the immediate next part of the normal
 // document scroll. The original photos are restored on reverse navigation.
 function activeDocumentScroller(){
   const wrapper=document.querySelector(".page-wrapper");
   if(wrapper && wrapper.scrollHeight>wrapper.clientHeight+2 &&
      /auto|scroll/.test(getComputedStyle(wrapper).overflowY))return wrapper;
   return document.scrollingElement||document.documentElement;
 }
 function clearDockDetailsHandoff(state){
   if(state.handoffEaseFrame){
     cancelAnimationFrame(state.handoffEaseFrame);
     state.handoffEaseFrame=0;
   }
   const media=state.handoffMedia;
   if(!media)return;
   for(const name of ["height","max-height","overflow","overflow-x","overflow-y"]){
     media.style.removeProperty(name);
   }
   media.classList.remove("pdp04-dock-handoff-media");
   state.handoffMedia=null;
   state.handoffAtScroll=null;
   state.handoffHasAdvanced=false;
   state.gestureStartY=null;
 }
 function activateDockDetailsHandoff(state){
   if(state.handoffMedia || !mobile() || menuIsOpen())return;
   const media=state.root.querySelector(".product-information__media");
   if(!media || !state.details.isConnected)return;
   const rect=media.getBoundingClientRect();
   const h=Math.max(70,state.dock.getBoundingClientRect().height);
   const vh=window.visualViewport?.height||window.innerHeight;
   // If we're already at details, don't alter the gallery.
   if(rect.bottom<=vh-h || rect.top>=vh)return;
   // Trim only the *remaining* image length, keeping the current photo at
   // the same viewport location. This reveals real inline details just above
   // the white rail as the user's finger continues its upward page scroll.
   const needed=Math.max(1,Math.ceil(vh-h+10-rect.top));
   const newLength=Math.min(rect.height,needed);
   if(newLength>=rect.height-2)return;
   state.handoffMedia=media;
   state.handoffAtScroll=activeDocumentScroller().scrollTop;
   state.handoffHasAdvanced=false;
   media.classList.add("pdp04-dock-handoff-media");
   // First preserve the ORIGINAL photo-strip size, then animate only its
   // remaining length. This avoids the abrupt multi-screen height collapse.
   const initialLength=Math.ceil(rect.height);
   media.style.setProperty("height",initialLength+"px","important");
   media.style.setProperty("max-height",initialLength+"px","important");
   media.style.setProperty("overflow","hidden","important");
   media.style.setProperty("overflow-x","hidden","important");
   media.style.setProperty("overflow-y","hidden","important");
   // Commit the starting geometry before scheduling the eased handoff.
   void media.offsetHeight;
   const reduce=matchMedia("(prefers-reduced-motion:reduce)").matches;
   const applyTarget=()=>{
     if(state.handoffMedia!==media || !media.isConnected)return;
     media.style.setProperty("height",newLength+"px","important");
     media.style.setProperty("max-height",newLength+"px","important");
     tick();
   };
   if(reduce){applyTarget();return;}
   requestAnimationFrame(applyTarget);
   // The rail's position and transparency follow the interpolated photo
   // boundary even if the user releases their finger mid-transition.
   const startTime=performance.now();
   const pdp04HandoffEaseFrame=(now)=>{
     state.handoffEaseFrame=0;
     if(state.handoffMedia!==media || !media.isConnected)return;
     tick();
     if(now-startTime<490){
       state.handoffEaseFrame=requestAnimationFrame(pdp04HandoffEaseFrame);
     }
   };
   state.handoffEaseFrame=requestAnimationFrame(pdp04HandoffEaseFrame);
 }
 function bindDockDetailsGesture(state){
   const dock=state.dock;
   // The browser still owns page scrolling; passive listeners never stop
   // the gesture. Simple taps retain Add to cart / Details functionality.
   state.dockTouchStart=(ev)=>{
     if(ev.touches.length!==1 || !mobile() || menuIsOpen())return;
     state.gestureStartY=ev.touches[0].clientY;
   };
   state.dockTouchMove=(ev)=>{
     if(state.gestureStartY==null || ev.touches.length!==1)return;
     const travelled=state.gestureStartY-ev.touches[0].clientY;
     if(travelled>14){
       activateDockDetailsHandoff(state);
       state.gestureStartY=null;
     }else if(travelled< -24 && state.handoffMedia){
       // On an intentional reverse swipe, restore the full photo sequence.
       clearDockDetailsHandoff(state);
       tick();
     }
   };
   state.dockTouchEnd=()=>{state.gestureStartY=null;};
   dock.addEventListener("touchstart",state.dockTouchStart,{passive:true});
   dock.addEventListener("touchmove",state.dockTouchMove,{passive:true});
   dock.addEventListener("touchend",state.dockTouchEnd,{passive:true});
   dock.addEventListener("touchcancel",state.dockTouchEnd,{passive:true});
   // Desktop emulators / trackpads: wheel gesture on white rail behaves
   // the same, but wheel scrolling remains native and uninterrupted.
   state.dockWheel=(ev)=>{
     if(ev.deltaY>8)activateDockDetailsHandoff(state);
     else if(ev.deltaY< -15 && state.handoffMedia &&
       activeDocumentScroller().scrollTop<=state.handoffAtScroll+40)
       clearDockDetailsHandoff(state);
   };
   dock.addEventListener("wheel",state.dockWheel,{passive:true});
 }
 function sync(state){
   if(!mobile())return;
   if(!state.root.isConnected){teardown(state);return;}
   const {root,details,dock,buy}=state;
   const native=details.querySelector('.buy-buttons-block button[name="add"]');
   const waiting=details.querySelector(".buy-buttons-block [data-e04-enter-room]");
   state.native=waiting||native;
   buy.disabled=!state.native||(!waiting&&(native?.disabled||native?.getAttribute("aria-disabled")==="true"));
   const label=buy.querySelector("[data-pdpref-buy-label]");
   const raw=waiting?"WAITING ROOM ↗":
     (native?.querySelector(".pdp04-atc-label")?.textContent?.trim()
       ||native?.textContent?.trim()||"ADD TO CART");
   const cleanLabel=raw.replace(/^\[|\]$/g,"").replace(/\s*\+\s*$/,"").trim().slice(0,26);
   if(label)label.textContent="["+cleanLabel+(!waiting&&!buy.disabled?"+":"")+"]";
   const price=details.querySelector('product-price[data-product-id] .reverse-sale-card__price,product-price[data-product-id] .price > bdi');
   if(price?.textContent?.trim())dock.querySelector("[data-pdpref-price]").textContent=price.textContent.trim();
   const h=Math.max(70,Math.ceil(dock.getBoundingClientRect().height));
   const newHeight=h+"px";
   if(root.style.getPropertyValue("--pdpref-rail-height")!==newHeight)
     root.style.setProperty("--pdpref-rail-height",newHeight);
   // Hand-off happens at the SIZE SELECTION / TRY ON area, not at the end
   // of all product, materials and shipping information.
   const picker=state.handoffTarget && state.handoffTarget.isConnected
     ?state.handoffTarget
     :details.querySelector(".pdp04-main-picker .pdp04-size-option, .pdp04-main-picker, [data-pdp-size-guide], variant-picker");
   state.handoffTarget=picker||null;
   const marker=picker?.getBoundingClientRect();
   const reachedSizing=!!marker && marker.top<=innerHeight-h-12;
   // Fallback only if no size-picker is available.
   const nativeForm=details.querySelector(".buy-buttons-block");
   const nativeTop=nativeForm?.getBoundingClientRect().top;
   const fallback=marker?false:(nativeTop!=null && nativeTop<=innerHeight-h-12);
   // The header follows the hero only as long as its floating Add to Cart
   // rail is actually visible. Same cutoff and state as the rail itself.
   // The navigation stays accessible while its mobile drawer is open.
   // Original [04] V1 handoff: native PAGE scroll only. When the last
   // photograph reaches the white rail, that same scroll lifts/fades the
   // rail away and reveals the real Shopify product information/ATC.
   const media=root.querySelector(".product-information__media");
   const mediaRect=media?.getBoundingClientRect();
   // Restore the complete photo strip once the user genuinely scrolls back
   // toward the photographs, before any missing media could appear.
   if(state.handoffMedia && state.handoffAtScroll!=null){
     const currentScroll=activeDocumentScroller().scrollTop;
     if(currentScroll>state.handoffAtScroll+35)state.handoffHasAdvanced=true;
     if(state.handoffHasAdvanced &&
       currentScroll<=Math.max(0,state.handoffAtScroll+12)){
       clearDockDetailsHandoff(state);
     }
   }
   const bounds=details.getBoundingClientRect();
   const visibleHeight=window.visualViewport?.height||innerHeight;
   const lift=mediaRect ? Math.max(0,Math.min(h,
     visibleHeight-h-mediaRect.bottom)) : h;
   const progress=Math.min(1,lift/Math.max(1,h));
   root.style.setProperty("--pdp04-dock-lift",(-Math.round(lift))+"px");
   root.style.setProperty("--pdp04-dock-opacity",
     String(Math.max(0,Math.min(1,(1-progress)/.52))));
   const show=mobile() && !menuIsOpen() && !!mediaRect
     && progress<.995 && bounds.bottom>h && !reachedSizing && !fallback;
   dock.dataset.visible=show?"true":"false";
   const navigationOpen=menuIsOpen();
   document.documentElement.classList.add("pdpref04-follow-header");
   document.documentElement.classList.toggle(
     "pdpref04-follow-header-paused",!show && !navigationOpen
   );
   // Keep the actual ASSIST tab out of the hero purchase rail.
   // Normal chat positioning resumes at the size picker hand-off.
   document.documentElement.classList.toggle("pdpref04-hero-dock-visible",!!show);
 }
 function tick(){
   if(raf)return;raf=requestAnimationFrame(()=>{raf=0;for(const item of seen)sync(item)});
 }
 function boot(root){
   // V4 EDITORIAL PARITY 12 OCT: shared product info across viewports.
   if(instances.has(root))return;
   const details=root.querySelector(".product-details");
   const dock=root.querySelector("[data-pdpref-dock]");
   const buy=dock?.querySelector("[data-pdpref-buy]");
   const info=dock?.querySelector("[data-pdpref-info]");
   if(!details||!dock||!buy)return;
   dock.hidden=!mobile();
   const state={root,details,dock,buy,info,native:null,
     originalRows:[],intro:null,materialOriginal:null,
     generatedMaterials:null,modelNote:null,modelSource:null,buyHandler:null,infoHandler:null};
   instances.set(root,state);seen.add(state);
   if(mobile())attachHeaderToViewport();
   ensureMaterialsDisclosure(state);
   makeHeaderLinks(state);
   moveMaterials(state);
   moveModelInfo(state);
   state.buyHandler=()=>{sync(state);if(!buy.disabled&&state.native)state.native.click()};
   buy.addEventListener("click",state.buyHandler);
   // PDP04_DIRECT_DETAILS_ERD_20261016
   // Only a tap on [Details] opens the actual Shopify Details accordion
   // and jumps there ONCE. It does not crop the photo gallery, animate
   // through its remaining photos, or create any detached information sheet.
   state.infoHandler=(event)=>{
     event?.preventDefault();
     if(!mobile() || menuIsOpen())return;
     const nativeDetails=accordionRow(details,"details");
     const target=nativeDetails||details;
     const owner=activeDocumentScroller();
     const previous=owner.style.getPropertyValue("scroll-behavior");
     const priority=owner.style.getPropertyPriority("scroll-behavior");
     const header=document.querySelector("#header-group > .header-section");
     const headerH=header?Math.min(96,Math.max(0,header.getBoundingClientRect().height)):0;
     // Suppress only this programmatic disclosure's transition.
     details.classList.add("pdp04-direct-details-open");
     if(nativeDetails)nativeDetails.open=true;
     const viewportOffset=owner===document.scrollingElement||owner===document.documentElement
       ?0:owner.getBoundingClientRect().top;
     const position=Math.max(0,owner.scrollTop+target.getBoundingClientRect().top-viewportOffset-headerH-10);
     owner.style.setProperty("scroll-behavior","auto","important");
     owner.scrollTop=position;
     // Clear a prior touch animation if the user tapped during a handoff,
     // without changing the selected photograph or opening a second panel.
     requestAnimationFrame(()=>{
       if(previous)owner.style.setProperty("scroll-behavior",previous,priority);
       else owner.style.removeProperty("scroll-behavior");
       requestAnimationFrame(()=>details.classList.remove("pdp04-direct-details-open"));
     });
     tick();
   };
   info?.addEventListener("click",state.infoHandler);
   bindDockDetailsGesture(state);
   // Prevent a tap on the dock from showing a stale cart when a variant changes.
   const observer=new MutationObserver(tick);
   observer.observe(details,{subtree:true,attributes:true,attributeFilter:["disabled","aria-disabled"],childList:true,characterData:true});
   state.observer=observer;
   sync(state);
 }
 function teardown(state){
   clearDockDetailsHandoff(state);
   state.dock.removeEventListener("touchstart",state.dockTouchStart);
   state.dock.removeEventListener("touchmove",state.dockTouchMove);
   state.dock.removeEventListener("touchend",state.dockTouchEnd);
   state.dock.removeEventListener("touchcancel",state.dockTouchEnd);
   state.dock.removeEventListener("wheel",state.dockWheel);
   state.observer?.disconnect();
   state.buy?.removeEventListener("click",state.buyHandler);
   state.info?.removeEventListener("click",state.infoHandler);
   document.documentElement.classList.remove("pdpref04-hero-dock-visible","pdpref04-follow-header","pdpref04-follow-header-paused");
   state.intro?.remove();
   const moved=state.materialOriginal;
   if(moved?.parent?.isConnected){
     const before=moved.nextSibling?.parentNode===moved.parent?moved.nextSibling:null;
     moved.parent.insertBefore(moved.note,before);
     moved.note.classList.remove("pdpref04-material-in-accordion");
   }
   state.generatedMaterials?.remove();
   state.modelNote?.remove();
   state.modelSource?.classList.remove("pdpref04-model-source-hidden");
   for(const saved of state.originalRows){
     saved.wrapper?.classList?.remove("pdpref04-source-collapsed","pdpref04-source-revealed");
     if(saved.row?.isConnected)saved.row.open=saved.originalOpen;
   }
   state.root.style.removeProperty("--pdp04-dock-lift");
   state.root.style.removeProperty("--pdp04-dock-opacity");
   state.root.style.removeProperty("--pdpref-rail-height");
   state.dock.dataset.visible="false";
   state.dock.hidden=true;
   seen.delete(state);instances.delete(state.root);
   if(seen.size===0)restoreHeaderPosition();
 }
 const start=()=>{
   // Shared details on desktop; floating purchase bar only on mobile/tablet.
   document.querySelectorAll(rootSelector).forEach(boot);
   if(mobile()){
     if(seen.size)attachHeaderToViewport();
     for(const state of seen)state.dock.hidden=false;
   }else{
     for(const state of seen)clearDockDetailsHandoff(state);
     restoreHeaderPosition();
     document.documentElement.classList.remove(
       "pdpref04-hero-dock-visible","pdpref04-follow-header","pdpref04-follow-header-paused"
     );
     for(const state of seen){
       state.dock.dataset.visible="false";
       state.dock.hidden=true;
     }
   }
   for(const state of [...seen])if(!state.root.isConnected)teardown(state);
   tick();
 };
 document.addEventListener("nav04:change",tick);
 document.addEventListener("toggle",(event)=>{
   if(event.target?.matches?.('header-drawer #Details-menu-drawer-container'))tick();
 },true);
 window.addEventListener("scroll",tick,{passive:true});
 // The theme can scroll .page-wrapper rather than window on iOS.
 document.addEventListener("scroll",tick,{passive:true,capture:true});
 window.addEventListener("resize",start,{passive:true});
 document.addEventListener("shopify:section:load",start);
 if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",start,{once:true});
 else start();
})();
